import { useQuery } from '@tanstack/react-query';

import api from '../../../utils/api';

export interface ScholarshipPendingRecord {
  applicantId: string;
  applicationNumber: string;
  firstName: string;
  lastName: string;
  middleName: string | null;
  email: string;
  phoneNumber: string;
  imageUrl: string | null;
  applicationBatchId: number;
  applicationBatchName: string;
  sessionName: string;
  programId: number;
  programName: string;
  programTypeId: number;
  programTypeName: string;
  modeOfStudyId: number;
  modeofStudyName: string;
  currentStageOrder: number;
  stageName: string;
  actedBy: string;
  actedAt: string;
  scholarshipApplicationId: number;
  originalFileName: string;
  filePath: string;
  submittedAt: string;
}

export const useGetScholarshipPendingByStageQuery = (stageOrder?: number, page = 1, pageSize = 10) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['get-scholarship-pending-by-stage', stageOrder, page, pageSize],
    queryFn: async () =>
      (
        await api.get(`/admin/scholarship/pending/${stageOrder}`, {
          params: { PageNumber: page, PageSize: pageSize },
        })
      )?.data,
    enabled: stageOrder !== undefined && stageOrder !== null,
  });

  const rawData = data?.data;
  const pendingRecords: ScholarshipPendingRecord[] = Array.isArray(rawData)
    ? rawData
    : (rawData?.data ?? []);
  const totalRecords: number = Array.isArray(rawData)
    ? (data?.totalRecords ?? pendingRecords.length)
    : (rawData?.totalRecords ?? pendingRecords.length);

  return { pendingRecords, totalRecords, isLoading, isError, error, refetch };
};
